export default class SamplePromptsTabs extends HTMLElement {
    connectedCallback() {
        this.mq = window.matchMedia('(max-width: 959px)');
        this.resolveElements();
        this.addListeners();
    }

    resolveElements() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = this.tabs.map((tab) =>
            document.getElementById(tab.getAttribute('aria-controls'))
        );
    }

    addListeners() {
        this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => this.onKeydown(e, i));
        });
    }

    select(index) {
        const isActive = this.tabs[index].getAttribute('aria-selected') === 'true';

        // On mobile: clicking the open item collapses it (toggle).
        // On desktop: selected tab always stays open.
        const activate = this.mq.matches ? !isActive : true;

        if (!this.mq.matches) {
            const prevIndex = this.tabs.findIndex(t => t.getAttribute('aria-selected') === 'true');
            if (prevIndex !== -1 && prevIndex !== index) {
                const goingRight = index > prevIndex;
                this.tabs[prevIndex].style.setProperty('--origin', goingRight ? 'right' : 'left');
                this.tabs[index].style.setProperty('--origin', goingRight ? 'left' : 'right');
            }
        }

        this.tabs.forEach((tab, i) => {
            const active = i === index && activate;
            tab.setAttribute('aria-selected', String(active));
            tab.classList.toggle('sample-prompts__tab-btn--active', active);
        });
        this.panels.forEach((panel, i) => {
            if (i === index && activate) {
                panel.removeAttribute('hidden');
            } else {
                panel.setAttribute('hidden', '');
            }
        });
    }

    onKeydown(e, index) {
        const map = {
            ArrowRight: (index + 1) % this.tabs.length,
            ArrowLeft: (index - 1 + this.tabs.length) % this.tabs.length,
            Home: 0,
            End: this.tabs.length - 1,
        };
        if (!(e.key in map)) return;
        e.preventDefault();
        const next = map[e.key];
        this.select(next);
        this.tabs[next].focus();
    }
}
